import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showSuccess, showConfirmation } from '../../services/alert';

const OperacaoCampoList = () => {
  const [operacoes, setOperacoes] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchOperacoes = async () => {
    setLoading(true);
    try {
      const res = await api.get('/operacoescampo');
      setOperacoes(res.data);
    } catch (err) {
      console.error('Erro ao buscar operações:', err);
      showError('Erro ao buscar operações.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOperacoes();
  }, []);

  const handleDelete = async (id) => {
    const confirmou = await showConfirmation({
      title: 'Excluir operação?',
      text: 'Essa ação não pode ser desfeita.',
      confirmText: 'Sim, excluir',
      cancelText: 'Cancelar',
    });
    if (!confirmou) return;

    try {
      await api.delete(`/operacoescampo/${id}`);
      showSuccess('Operação excluída com sucesso.');
      fetchOperacoes();
    } catch (err) {
      console.error('Erro ao excluir operação:', err);
      showError('Erro ao excluir operação.');
    }
  };

  const columns = [
    { name: 'Safra', selector: row => row.safraNome, sortable: true },
    { name: 'Talhão', selector: row => row.talhaoNome || '-', sortable: true },
    { name: 'Máquina', selector: row => row.maquinaNome || '-', sortable: true },
    { name: 'Tipo', selector: row => row.tipo, sortable: true },
    { name: 'Data', selector: row => new Date(row.data).toLocaleDateString(), sortable: true },
    { name: 'Custo', selector: row => Number(row.custoOperacional || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), sortable: true },
    { name: 'Descrição', selector: row => row.descricao, sortable: true },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => navigate(`/operacoes-campo/editar/${row.id}`)}
          >
            <i className="bi bi-pencil-square"></i> Editar
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i> Excluir
          </button>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
              disabled={loading}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Operações de Campo</h5>
              <small className="text-white-50">Histórico de atividades em cada safra</small>
            </div>
          </div>
          <button
            className="btn btn-light text-success fw-bold"
            onClick={() => navigate('/operacoes-campo/create')}
          >
            <i className="bi bi-plus-circle"></i> Nova operação
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={operacoes}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhuma operação encontrada.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default OperacaoCampoList;
